import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ACCOUNT_ROUTE } from '@/utils/appRoutes';

type BackNavigationState = { listSearch?: string } | null;

type BackRoute = {
  pattern: RegExp;
  getTarget: (match: RegExpMatchArray, state: BackNavigationState) => string;
};

const backRoutes: BackRoute[] = [
  {
    pattern: /^\/agents\/(\d+)\/conversation\/\d+$/,
    // listSearch is put there by the conversation row that was clicked, so
    // Back returns to the page and filters the reader actually had. It is
    // absent on a reload or a pasted link, which falls back to an unfiltered
    // first page.
    getTarget: (m, state) =>
      state?.listSearch
        ? `/agents/${m[1]}${state.listSearch}`
        : `/agents/${m[1]}?tab=conversations`,
  },
  {
    pattern:
      /^\/agents\/(\d+)\/(statistics|usage|contacts|settings|conversations|business)$/,
    getTarget: m => `/agents/${m[1]}?tab=${m[2]}`,
  },
  {
    pattern: /^\/agents\/(\d+)\/?$/,
    getTarget: () => '/home',
  },
  {
    pattern: /^\/agents\/new$/,
    getTarget: () => '/home',
  },
  {
    pattern: /^\/change-password$/,
    getTarget: () => ACCOUNT_ROUTE,
  },
  {
    pattern: /^\/help\/forwarding$/,
    getTarget: () => '/help',
  },
];

export function useBackNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = useCallback(() => {
    const { pathname } = location;
    const state = location.state as BackNavigationState;

    for (const route of backRoutes) {
      const match = pathname.match(route.pattern);
      if (match) {
        navigate(route.getTarget(match, state));
        return;
      }
    }

    navigate(-1);
  }, [location, navigate]);

  return handleBack;
}
